// @flow

import * as React from 'react';
import { editStaffVenueRelevanceScoresPath } from 'routes';
import FontAwesomeIcon, {
  solidSliders
} from 'common/components/FontAwesomeIcon';
import styles from './EditRelevanceLink.module.scss';

export const editRelevanceLinkWrapperClass = styles.wrapper;

type Props = { venueId: number, ... };

function EditRelevanceLink(props: Props): React.Node {
  return (
    <a
      href={editStaffVenueRelevanceScoresPath({ venue_id: props.venueId })}
      className={styles.link}
      title="Edit relevance scores for this venue"
    >
      <FontAwesomeIcon icon={solidSliders} />
    </a>
  );
}

export default EditRelevanceLink;
